<ng-template #content role="document" let-modal>
    <div class="modal-header bg-light p-3">
        <h5 class="modal-title" id="exampleModalLabel">Add Customer</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="mb-3">
            <label for="customername-field" class="form-label">Group Name</label>
            <input type="text" id="customername-field" class="form-control" placeholder="Enter Group Name"
                [(ngModel)]="customerGroup.gorup_name" />
        </div>

        <div class="mb-3">
            <label for="email-field" class="form-label">Customer</label>
            <!-- <ng-select [(ngModel)]="customerGroup.customer_ids" name="collectionList" placeholder="Collection"
                [multiple]="true">
                <ng-option *ngFor="let data of customerList" [value]="data._id">
                    {{data.name}}</ng-option>
            </ng-select> -->
        </div>

    </div>
    <div class="modal-footer">
        <div class="hstack gap-2 justify-content-end">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal"
                (click)="modal.close('Close click')">Close</button>
            <!-- <button type="submit" class="btn btn-primary" (click)="addCustomerGroup()" id="add-btn">Add
                Customer</button> -->
        </div>
    </div>
</ng-template>